import { Apollo } from 'apollo-angular';
import { Component, Inject, LOCALE_ID, Renderer2 } from '@angular/core';
import { take, takeUntil } from 'rxjs/operators';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { SystemPages, SystemPagesResponse } from 'src/app/apollo/models/base-models';
import { SYSTEM_PAGE_CONTENT_QUERY } from 'src/app/apollo/static-page';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { RedeemCodeService } from 'src/app/services/client-area/redeem-code.service';
import { REDEEM_CODE_STATUS_SMS_VERIFY, REDEEM_CODE_STATUS_SUMSUB_VERIFY, REDEEM_CODE_STATUS_FULL_dATA, RedeemCodeResponse } from 'src/app/services/client-area/client-area.models';
import { BasePageComponent } from 'src/app/components/base-page/base-page.component';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { SignupVerifySmsComponent } from 'src/app/components/auth/signup/signup-verify-sms/signup-verify-sms.component';
import { RegistrationService } from 'src/app/services/signup/registration-fields.service';
import { MatDialog } from '@angular/material/dialog';
import { LoginSmsVerificationService } from 'src/app/services/auth/login/login-sms-verification.service';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { clientAreaTrx, bonusQueueTrx, uploadDocumentsTrx, editProfileTrx, supportTrx, redeemPromocodeTrx } from 'src/app/router-translation.labels';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { StaticPageComponent } from 'src/app/components/static-page/static-page.component';
import { LICENCE } from 'src/app/global.tokens';
import { DialogClosePreviousUrl } from 'src/app/services/utils/dialog-close-previouse-url.service';


@Component({
  selector: 'app-redeem-promocode',
  templateUrl: './redeem-promocode.component.html',
  styleUrls: ['./redeem-promocode.component.scss']
})
export class RedeemPromocodeComponent extends SignupVerifySmsComponent {

  page: SystemPages;
  body: SafeHtml;
  redeemFormSubmited: boolean = false;
  errorMsg: string;
  hasError: boolean = false;

  isFulldataVerification = false;
  isSumsubVerification = false;

  readonly supportUrl: string = '/' + this.translationConfig.getTranslation(supportTrx);
  readonly editProfileUrl: string = '/' + this.translationConfig.getTranslation(editProfileTrx);
  readonly uploadDocumentsUrl: string = '/' + this.translationConfig.getTranslation(uploadDocumentsTrx);
  public bonusQueueUrl = ["", this.translationConfig.getTranslation(clientAreaTrx), this.translationConfig.getTranslation(bonusQueueTrx)];

  redeemCodeResponse: RedeemCodeResponse;
  readonly genericError: string = $localize`:@@promo-code-error:There was some error adding promocode.`;


  redeemCodeForm = this.formBuilder.group({
    code: ['', [Validators.required]],
  });

  constructor(private apollo: Apollo,
    protected formBuilder: UntypedFormBuilder,
    protected redeemCodeService: RedeemCodeService,
    public detectDeviceService: DetectDeviceService,
    protected route: ActivatedRoute,
    private translationConfig: TranslationConfig,
    dialog: MatDialog,
    @Inject(LOCALE_ID) public locale: string,
    @Inject(LICENCE) public licence: string,
    protected licenceService: LicenceService,
    protected registrationService: RegistrationService,
    protected loginWithSms: LoginSmsVerificationService,
    protected loginStatusService: LoginStatusService,
    protected renderer: Renderer2,
    protected sanitizer: DomSanitizer,
    private licenceConfigService: LicenceService,
    private router: Router,
    private returnUrlService: DialogClosePreviousUrl,
  ) {
    super(formBuilder,
      registrationService,
      dialog,
      detectDeviceService,
      loginWithSms,
      renderer,
      licenceService
    )
  }

  ngOnInit(): void {
    this.isPromocdeFlow = true;
    this.isDesktop = this.detectDeviceService.isDesktop();
    // this.isSmsVerification = true;
    this.loginStatusService.getIfUserLogged().pipe(
      take(1),
    ).subscribe(resp => {
      this.telephone = resp.fullInfo.telephone.startsWith('+') ? resp.fullInfo.telephone : '+' + resp.fullInfo.telephone;
      this.apollo.watchQuery<SystemPagesResponse>({
        query: SYSTEM_PAGE_CONTENT_QUERY,
        variables: {
          pageName: "redeem-promocode",
          locale: this.locale,
          licence: this.licence
        }
      }).valueChanges.pipe(take(1),).subscribe((resp) => {
        this.page = resp.data.systemPages[0];

        this.body = this.sanitizer.bypassSecurityTrustHtml(StaticPageComponent.replaceTemplateTags(this.page.content.html, this.licenceConfigService));
      }, (error) => {

      });
      const code = this.route.snapshot.paramMap.get('code');
      if (code) {
        this.getCode(code);
      }
    })


  }

  onSubmit(redeemCodeForm) {
    if (this.redeemFormSubmited || !redeemCodeForm.valid) return;
    this.errorMsg = null;
    this.redeemFormSubmited = true;
    this.redeemCodeService.requestRedeemCode(redeemCodeForm).pipe(takeUntil(this.unsubscribe)).subscribe((resp: RedeemCodeResponse) => {
      this.redeemCodeResponse = resp;
      switch (resp.status) {
        case REDEEM_CODE_STATUS_FULL_dATA:
          this.isFulldataVerification = true; 
          break;

        case REDEEM_CODE_STATUS_SUMSUB_VERIFY:
          this.isSumsubVerification = true; 
          break;

        case REDEEM_CODE_STATUS_SMS_VERIFY:
          this.isSmsVerification = true; 
          break;

        default:  
          this.isReedeemCompleted = true;
          break;
      }
    }, err => {
      this.redeemFormSubmited = false;
      if (err.status === 400) {
        this.errorMsg = !!err.error.errors?.code ? err.error.errors.code : !!err.error.detail ? err.error.detail : this.genericError;
        this.hasError = true;
        this.openErrorDialog(this.errorMsg)
      } else {
        this.openErrorDialog();
      }
    });
  }

  onSmsSuccessVerification(resp): void {

  }

  onSmsSubmit(smsForm) {
    super.onSubmit(smsForm, this.onSmsSuccessVerification);
  }

  getCode(code: any) {
    this.redeemCodeForm.controls.code.setValue(code);
  }
  closeDialog(): void {
    this.isSmsVerification = true;
    this.pageView = null;
    this.isChangePhone = false;
  }

  onCloseEvent(url?: string): void {
    if (url) {
      this.router.navigateByUrl(url);
    } else {
      // Navigate back to client area main page
      this.router.navigate([this.translationConfig.getTranslation(clientAreaTrx)]);
    }
  }
  openModal() {
  }
  changePhoneNumber() { }

  editProfile() {
    this.router.navigateByUrl(this.editProfileUrl);
  }

  verifyProfile()  {
    this.returnUrlService.setUrl([this.translationConfig.getTranslation(clientAreaTrx), this.translationConfig.getTranslation(redeemPromocodeTrx)]);
    this.router.navigateByUrl(this.uploadDocumentsUrl);
  }
}
